var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tinymce',{ref:"editor",staticClass:"elevation-0",staticStyle:{"width":"100%","margin-top":"1px"},attrs:{"id":_vm.id,"value":_vm.value,"toolbar1":"formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | image media print code removeformat fullscreen","plugins":[
    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
    'searchreplace wordcount visualblocks visualchars code fullscreen',
    'insertdatetime media nonbreaking table contextmenu directionality',
    'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample'],"other_options":{

    height: _vm.height, // 높이지정

    menubar: false,  // 메뉴바 감추기
    statusbar: true, // 상태바 감추기

    language_url: '/front/tinymce/langs/ko_KR.js', // 한글로 나오게. https://www.tiny.cloud/get-tiny/language-packages/ 에서 다운받아서 추가함.

    // 엔터치면 br ( 3개 옵션 다 필요 )
    force_br_newlines : true,
    force_p_newlines  : false,
    forced_root_block : '',

    paste_data_images: true,

    content_css : '/front/tinymce/editor.css',
  }},on:{"input":function($event){return _vm.$emit('input', $event)},"editorInit":_vm.initdEditor}})}
var staticRenderFns = []

export { render, staticRenderFns }